import React from "react";
import FiltersBarMobile$ from "@deosite/components-new/FiltersBarMobile";

import Button from "@deosite/components-new/buttons/Button";
import ButtonMinimalIcon from "@deosite/components-new/buttons/ButtonMinimalIcon";
import ButtonMinimal from "@deosite/components-new/buttons/ButtonMinimal";
import Input from "../formControls/input/Input";
import ItemRowCheckmark from "../selectables/ItemRowCheckmark";
import ItemRow from "../selectables/ItemRow";

const FiltersBarMobile = props => {
  const propsExt = {
    ...props,
    button: <Button />,
    buttonMinimal: <ButtonMinimal />,
    input: <Input />,
    itemRow: <ItemRow />,
    itemRowCheckmark: <ItemRowCheckmark />,
    buttonMinimalIcon: <ButtonMinimalIcon />
  };
  return <FiltersBarMobile$ {...propsExt} />;
};

export default FiltersBarMobile;
